document.addEventListener("DOMContentLoaded", (event) => {
  // Initialize Intersection Observer
  const observer = new IntersectionObserver((entries, observerInstance) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible'); // Add the visible class
        observerInstance.unobserve(entry.target); // Stop observing once visible
      }
    });
  });

  // Select all .shopify-section elements and observe them
  const shopifySections = document.querySelectorAll('main .shopify-section');
  shopifySections.forEach(section => {
    observer.observe(section);
  });

  // Polling for .shopify-pc__banner__dialog
  const waitForElement = () => {
    const shopifyDialog = document.querySelector('body .shopify-pc__banner__dialog');
    if (shopifyDialog) {
      observer.observe(shopifyDialog); // Start observing the dialog
    } else {
      setTimeout(waitForElement, 100); // Check again after 100ms
    }
  };
  
  const waitForKl = () => {
    const klDialog = document.querySelector('button.needsclick.kl-teaser-Vy7AHK');
    if (klDialog) {
      observer.observe(klDialog); // Start observing the dialog
    } else {
      setTimeout(waitForKl, 100); // Check again after 100ms
    }
  };
  waitForKl();
});
